import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames"; // import PropTypes from "prop-types";

import config from "../../../../config"; // import Status from 'components/Status';

import "./StreetView.scss";
export var StreetView = function StreetView(a) {
  var b = a.name,
      c = a.slug,
      d = a.image,
      e = a.lots,
      f = a.hovered,
      g = a.active,
      h = a.onHover,
      i = _objectWithoutProperties(a, ["name", "slug", "image", "lots", "hovered", "active", "onHover"]),
      j = function onClick(a, b) {
    b.preventDefault(), "function" == typeof h && i.onClick(a);
  },
      k = function onMouseEnter(a) {
    "function" == typeof h && h(a);
  },
      l = function onMouseLeave() {
    "function" == typeof h && h(null);
  },
      m = d.url,
      n = e.reduce(function (a, b) {
    var c = b.coords,
        d = c && c.split(","),
        e = _slicedToArray(d, 1),
        f = e[0];

    return a + parseInt(f);
  }, 0);

  return /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--streetview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--streetview__scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-townhomes--streetview__wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: m,
    className: "ta-townhomes--streetview--image",
    alt: b
  }), /*#__PURE__*/React.createElement("ul", null, e.map(function (a) {
    var b = a.coords,
        c = a.slug,
        d = a.status,
        e = a.name,
        h = b.split(","),
        i = _slicedToArray(h, 1),
        m = i[0],
        o = classnames({
      active: c === g,
      hovered: c === f
    }),
        p = config.status.get(d, {
      slug: !0
    }),
        q = config.status.get(d);

    return /*#__PURE__*/React.createElement("li", {
      key: c,
      style: {
        width: 100 * m / n + "%"
      },
      className: classnames(p)
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(o, "item"),
      onClick: function onClick(a) {
        return 1 === d && j(c, a);
      },
      onMouseEnter: function onMouseEnter() {
        return k(c);
      },
      onMouseLeave: function onMouseLeave() {
        return l(c);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "ta-townhomes--streetview--data"
    }, /*#__PURE__*/React.createElement("span", null, "Lot ", e), q)));
  })))));
};
export default StreetView;